import React,{useEffect,useState} from 'react';
import './home_banner.css';
import {sortList} from '../function_lib/common_lib';
import TextToHtml from './text_html';
import { appGetUrlPath } from '../function_lib/common_cms';

export const Home_Banner2Div_n=(props)=>{
    useEffect(()=>{

    },[props.lsData]);
    
    var appPath=appGetUrlPath();

    return(<div data-aos="zoom-in-down" class="hero_home fixed-p11 section">
    <div class="hero-slider swiper-container slider-nav-style-1 slider-dot-style-1 dot-color-white">
         <div class="swiper-wrapper">
            {/* content part */}
            {props.lsData.map((item,index)=>{
                //alert(JSON.stringify(item));
                 let styleRBg=""; 
                 if(item["col15"].trim()!==""){
                     styleRBg=item["col15"].trim();
                     //alert("i m in sytle=="+styleRBg);
                  }
                  let rfUrl="javascript:void(0)";
                  if(item["col7"].trim()!==""){
                     rfUrl=item["col7"].trim();
                  }
                  let rfText="know more";
                  if(item["col8"].trim()!==""){
                    rfText=item["col8"].trim();
                  }
                return(<div data-aos="zoom-out" class="hero-slide-item  bg-banner211 gb-anim1 slider-height swiper-slide d-flex">
      <div  class="container align-self-center">
      <div class="row ">
          <div  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 bg-gray-ligh11 align-self-center text-center">
              <div class="hero-slide-content slider-animated-1  center">
                
                  <h2 class="title-1 white11">{item["col1"]}</h2>
                  {/* <div data-aos="zoom-out"><TextToHtml text={item["col2"]}/></div>
                  {rfUrl!=="javascript:void(0)"?<a href={rfUrl} class="btn btn-lg btn-primary btn-hover-dark mt-5">{rfText}</a>:''} */}
                  
              </div>
          </div>
          {item["col4"].trim()!==""?
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 bg-gray-ligh11  bg-rectangle-animation">
              <div class="hero-slide-image center img-bg-shape">
                <img src={appPath+item["col4"]} alt="banner" />
                  
              </div>
          </div>:''}

          <div  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 bg-gray-ligh11 align-self-center text-center">
              <div class="hero-slide-content slider-animated-1  center">
                
                  
                  <div data-aos="zoom-out"><TextToHtml text={item["col2"]}/></div>
                  {rfUrl!=="javascript:void(0)"?<a href={rfUrl} class="btn btn-lg btn-primary btn-hover-dark mt-5">{rfText}</a>:''}
                  
              </div>
          </div>

      </div>
  </div>
      
   </div>)
            })}
            {/* end of content part */}
         </div><div class="swiper-pagination swiper-pagination-white"></div>
            <div class="swiper-buttons">
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>
</div>
</div>
         )
}

export const Home_Banner_VideoNewsVirtical=(props)=>{
    let appPath=appGetUrlPath();
    const [lData,setLData]=useState([]);
    let lsData=[];
    useEffect(()=>{
        // alert(JSON.stringify(props.news_data))
        if(props.lsData.length>0){
            //alert(props.lsData[0]["col14"]);
            if(props.lsData[0]["col14"]!==""){
                //alert(lsData[0]["col14"]);
                lsData=sortList(props.lsData,"col14",false,true);
                
                //alert("i min sorting");
            }else{
                lsData=props.lsData;
            }
            setLData(lsData);
            //alert(lData.length);
        }

    },[props.lsData]);
    return(
    <div className='row'>
        <div class="col-md-8 col-sm-12">
   
{/* content part */}
{lData.map((item,index)=>{
     let styleRBg=""; 
     if(item["col15"].trim()!==""){
         styleRBg=item["col15"].trim();
         //alert("i m in sytle=="+styleRBg);
      }
      let rfUrl="javascript:void(0)";
      if(item["col7"].trim()!==""){
         rfUrl=item["col7"].trim();
      }
    return(
        <video style={{"width":"100%"}} autoPlay={true} muted loop playsInLine>
        <source  src={appPath+item["col4"]} type="video/mp4"/>
    </video>
      
    )
})}
{/* end of content part */}

           
</div>
{/* End of Home Banner */}

{/* News Slider Div */}
<div className='col-md-4 col-sm-12'>
<div class="dual-section-container">
             <div class="card">
                 <div class="card-header">
                     <h4 class="white"><i class="fa fa-newspaper-o"></i> Latest Update</h4>
                 </div>
                 <div class="card-body">
                 
                     <div class="scroll-content">
                     {props.news_data.map((item,index)=>{
                        var urlTitle= item["col1"];
                        urlTitle=urlTitle.replace("?","_");
                        urlTitle=urlTitle.replace(" ","-");
                        let clpUrl="..\\blog\\"+urlTitle+"?rf="+item["e_id"];
                        if(item["col7"]!==""){
                            clpUrl="..\\"+item["col7"];
                        }
                        if(item["col7"]==="read_now"){
                            //alert("i m in condition "+lsData[i]["col7"]+urlTitle+"?rf="+lsData[i]["e_id"]);
                            clpUrl="..\\"+item["col7"]+"\\"+urlTitle+"?rf="+item["e_id"];
                            //alert(clpUrl);
                        }
                        if(item["col7"].indexOf("://")!==-1){
                           clpUrl=item["col7"];
                        }

                        return <a href={clpUrl} class="news-item">
                        <i class="fa fa-chevron-circle-right" aria-hidden="true"></i>
                        <div class="news-content">
                        
                            {/* <span class="news-category cat-tech">BSN</span> */}
                            <div class="news-title">{item["col1"]}</div>
                            {/* <div class="news-excerpt">{item["col2"]}</div> */}
                            {/* <div class="news-meta">
                                <span><i class="fa fa-clock-o"></i> 15 min ago</span>
                            </div> */}
                        </div>
                    </a>
                    })}
                    </div>
                 </div>
             </div>
         </div>
</div>
{/* End of News Slider  */}
</div>
                )
}

export const Home_Banner_WithNewsVirtical=(props)=>{
    
    let appPath=appGetUrlPath();
    const [lData,setLData]=useState([]);
    let lsData=[];
    useEffect(()=>{
        // alert(JSON.stringify(props.news_data))
        if(props.lsData.length>0){
            //alert(props.lsData[0]["col14"]);
            if(props.lsData[0]["col14"]!==""){
                //alert(lsData[0]["col14"]);
                lsData=sortList(props.lsData,"col14",false,true);
                
                //alert("i min sorting");
            }else{
                lsData=props.lsData;
            }
            setLData(lsData);
            //alert(lData.length);
        }

    },[props.lsData]);
    return(
    <div className='row'>
        <div class="col-md-8 col-sm-12">
    <div data-aos="zoom-in-down" class="hero-slider-70 hero_home section">
        <div class="hero-slider swiper-container slider-nav-style-1 slider-dot-style-1 dot-color-white">
             <div class="swiper-wrapper">
{/* content part */}
{lData.map((item,index)=>{
     let styleRBg=""; 
     if(item["col15"].trim()!==""){
         styleRBg=item["col15"].trim();
         //alert("i m in sytle=="+styleRBg);
      }
      let rfUrl="javascript:void(0)";
      if(item["col7"].trim()!==""){
         rfUrl=item["col7"].trim();
      }
    return(<div class="hero-slide-item slider-height-2 swiper-slide d-flex">
       
       <div class="hero-bg-image">
       <a href={rfUrl}>
           <img src={appPath+item["col4"]} style={{"position":"relative"}} alt="banner"/>
        </a>
       </div>
       {item["col1"]!==""?
       <div class="container align-self-center overlay">
                        <div class="row justify-content-center">
                            <div class="col-md-8 offset-2 align-self-center m-auto">
                                <div class="hero-slide-content hero-slide-content-2 slider-animated-1 text-center">
                                    <span class="category">{item["col1"]}</span>
                                    <h2 class="title-1"><TextToHtml text={item["col2"]}/></h2>
                                    <p class="w-100"><TextToHtml text={item["col3"]}/></p>
                                    
                                </div>
                            </div>
                        </div>
                    </div>:''}
    </div>)
})}
{/* end of content part */}

             </div>
    
    <div class="swiper-pagination swiper-pagination-white\"></div>
            <div class="swiper-buttons">
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>
   
</div>
{/* <div id="latest_update">place test</div> */}
</div>
</div>
{/* End of Home Banner */}

{/* News Slider Div */}
<div className='col-md-4 col-sm-12'>
<div class="dual-section-container">
             <div class="card">
                 <div class="card-header">
                     <h4><i class="fa fa-newspaper-o"></i> Latest News</h4>
                 </div>
                 <div class="card-body">
                 
                     <div class="scroll-content">
                     {props.news_data.map((item,index)=>{
                        var urlTitle= item["col1"];
                        urlTitle=urlTitle.replace("?","_");
                        urlTitle=urlTitle.replace(" ","-");
                        let clpUrl="..\\blog\\"+urlTitle+"?rf="+item["e_id"];
                        if(item["col7"]!==""){
                            clpUrl="..\\"+item["col7"];
                        }
                        if(item["col7"]==="read_now"){
                            //alert("i m in condition "+lsData[i]["col7"]+urlTitle+"?rf="+lsData[i]["e_id"]);
                            clpUrl="..\\"+item["col7"]+"\\"+urlTitle+"?rf="+item["e_id"];
                            //alert(clpUrl);
                        }
                        if(item["col7"].indexOf("://")!==-1){
                           clpUrl=item["col7"];
                        }

                        return <a href={clpUrl} class="news-item">
                        <img src={appPath+item["col4"]} alt="Tech News" class="news-image"/>
                        <div class="news-content">
                            <span class="news-category cat-tech">BSN</span>
                            <div class="news-title">{item["col1"]}</div>
                            <div class="news-excerpt">{item["col2"]}</div>
                            {/* <div class="news-meta">
                                <span><i class="fa fa-clock-o"></i> 15 min ago</span>
                            </div> */}
                        </div>
                    </a>
                    })}
                    </div>
                 </div>
             </div>
         </div>
</div>
{/* End of News Slider  */}
</div>
                )
}
export const Home_Banner_WithNews_n=(props)=>{
    
    let appPath=appGetUrlPath();
    const [lData,setLData]=useState([]);
    let lsData=[];
    useEffect(()=>{
        if(props.lsData.length>0){
            //alert(props.lsData[0]["col14"]);
            if(props.lsData[0]["col14"]!==""){
                //alert(lsData[0]["col14"]);
                lsData=sortList(props.lsData,"col14",false,true);
                
                //alert("i min sorting");
            }else{
                lsData=props.lsData;
            }
            setLData(lsData);
            //alert(lData.length);
        }

    },[props.lsData]);
    return(<div data-aos="zoom-in-down" class="hero-slider-70 hero_home section">
        <div class="hero-slider swiper-container slider-nav-style-1 slider-dot-style-1 dot-color-white">
             <div class="swiper-wrapper">
{/* content part */}
{lData.map((item,index)=>{
     let styleRBg=""; 
     if(item["col15"].trim()!==""){
         styleRBg=item["col15"].trim();
         //alert("i m in sytle=="+styleRBg);
      }
      let rfUrl="javascript:void(0)";
      if(item["col7"].trim()!==""){
         rfUrl=item["col7"].trim();
      }
    return(<div class="hero-slide-item slider-height-2 swiper-slide d-flex">
       
       <div class="hero-bg-image">
       <a href={rfUrl}>
           <img src={appPath+item["col4"]} style={{"position":"relative"}} alt="banner"/>
        </a>
       </div>
       {item["col1"]!==""?
       <div class="container align-self-center overlay">
                        <div class="row justify-content-center">
                            <div class="col-md-8 offset-2 align-self-center m-auto">
                                <div class="hero-slide-content hero-slide-content-2 slider-animated-1 text-center">
                                    <span class="category">{item["col1"]}</span>
                                    <h2 class="title-1"><TextToHtml text={item["col2"]}/></h2>
                                    <p class="w-100"><TextToHtml text={item["col3"]}/></p>
                                    
                                </div>
                            </div>
                        </div>
                    </div>:''}
    </div>)
})}
{/* end of content part */}

             </div>
    
    <div class="swiper-pagination swiper-pagination-white\"></div>
            <div class="swiper-buttons">
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
    </div>
   
</div>
{/* <div id="latest_update">place test</div> */}
</div>
                )
}

export function Home_Banner_WithNews(lsData){
    var appPath=appGetUrlPath();
    var strResp="";
    if(lsData.length>0){
        if(lsData[0]["col14"]!==""){
            //alert(lsData[0]["col14"]);
            lsData=sortList(lsData,"col14",false,true);
            //alert("i min sorting");
        }
    }
  
    var strHeader="<div data-aos=\"zoom-in-down\" class=\"hero-slider-70 hero_home section\">"+
    "<div class=\"hero-slider swiper-container slider-nav-style-1 slider-dot-style-1 dot-color-white\">"+
         "<div class=\"swiper-wrapper\">";
    var strFooter="</div>"+
    
    "<div class=\"swiper-pagination swiper-pagination-white\"></div>"+
            "<div class=\"swiper-buttons\">"+
        "<div class=\"swiper-button-next\"></div>"+
        "<div class=\"swiper-button-prev\"></div>"+
    "</div>"+
   
"</div>"+
"<div id=\"latest_update\">"+"place test"+"</div>"+
"</div>";
    for(var i=0;i<lsData.length;i++){
        let styleRBg=""; 
        if(lsData[i]["col15"].trim()!==""){
            styleRBg=lsData[i]["col15"].trim();
            //alert("i m in sytle=="+styleRBg);
         }
         let rfUrl="javascript:void(0)";
         if(lsData[i]["col7"].trim()!==""){
            rfUrl=lsData[i]["col7"].trim();
         }
       strResp+="<div class=\"hero-slide-item slider-height-2 swiper-slide d-flex\">"+
       
       "<div class=\"hero-bg-image\">"+
       "<a href=\""+rfUrl+"\">"+
           "<img src=\""+appPath+lsData[i]["col4"]+"\" style=\"position:relative\" alt=\"banner\"/>"+
        "</a>"+
       "</div>"+
       "<div class=\"container align-self-center overlay\">"+
                        "<div class=\"row justify-content-center\">"+
                            "<div class=\"col-md-8 offset-2 align-self-center m-auto\">"+
                                "<div class=\"hero-slide-content hero-slide-content-2 slider-animated-1 text-center\">"+
                                    "<span class=\"category\">"+lsData[i]["col1"]+"</span>"+
                                    "<h2 class=\"title-1\">"+lsData[i]["col2"]+"</h2>"+
                                    "<p class=\"w-100\">"+lsData[i]["col3"]+"</p>"+
                                    // "<a href=\"#\" class=\"btn btn-lg btn-primary btn-hover-dark mt-5\">Shop Now12</a>"+
                                "</div>"+
                            "</div>"+
                        "</div>"+
                    "</div>"+
    "</div>";
    }
    return strHeader+strResp+strFooter;
}
export function Home_Banner(lsData){
    var appPath=appGetUrlPath();
    var strResp="";
  
    var strHeader="<div data-aos=\"zoom-in-down\" class=\"hero_home section\">"+
    "<div class=\"hero-slider swiper-container slider-nav-style-1 slider-dot-style-1 dot-color-white\">"+
         "<div class=\"swiper-wrapper\">";
    var strFooter="</div><div class=\"swiper-pagination swiper-pagination-white\"></div>"+
            "<div class=\"swiper-buttons\">"+
        "<div class=\"swiper-button-next\"></div>"+
        "<div class=\"swiper-button-prev\"></div>"+
    "</div>"+
"</div>"+
"</div>";
    for(var i=0;i<lsData.length;i++){
        let styleRBg=""; 
        if(lsData[i]["col15"].trim()!==""){
            styleRBg=lsData[i]["col15"].trim();
            //alert("i m in sytle=="+styleRBg);
         }
         let rfUrl="javascript:void(0)";
         if(lsData[i]["col7"].trim()!==""){
            rfUrl=lsData[i]["col7"].trim();
         }
       strResp+="<div class=\"hero-slide-item slider-height-2 swiper-slide d-flex\">"+
       
       "<div class=\"hero-bg-image\">"+
       "<a href=\""+rfUrl+"\">"+
           "<img src=\""+appPath+lsData[i]["col4"]+"\" alt=\"banner\"/>"+
        "</a>"+
       "</div>"+
    //    "<div class=\"container1\" style=\"background-color:"+styleRBg+";width:100%\">"+
    //        "<div class=\"row\">"+
    //            "<div class=\"col-md-5 align-self-center txt_on_slider\">"+
    //                "<div class=\"hero-slide-content hero-slide-content-2 slider-animated-1 text-center\">"+
    //                    "<span class=\"category\">"+lsData[i]["col1"]+"</span>"+
    //                    "<p class=\"w-100\">"+lsData[i]["col2"]+"</p>"+
    //                     "<a href=\"../products\" class=\"btn btn-lg btn-primary btn-hover-dark mt-5\">Shop Now</a>"+
    //                "</div>"+
    //            "</div>"+
    //        "</div>"+
    //    "</div>"+
      
   "</div>";
    }
    return strHeader+strResp+strFooter;
}
export default Home_Banner;